import {GET_EVENT_SUCCESS} from '../../../constants/PlayerConstants';
import {ActionWithoutPayload} from "../../../@types/actions";

export const ClearEventPlayersAction = (): ActionWithoutPayload<any> => ({
    type: GET_EVENT_SUCCESS
});
